import axios from '@axios'
import store from '@/store'

const emptyPagination = () => ({ data: [], meta: { total: 0 }, links: {} })

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(item => ({
        value: item.id,
        label: item.name || String(item.id),
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async export(_, params) {
      const response = await axios.get('v1/unit-commanders', {
        params,
        responseType: 'blob',
      })

      if (!response.data) {
        return
      }

      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
      )
      const link = document.createElement('a')
      link.href = url
      const disposition = response.headers['content-disposition']
      const downloadName = disposition ? disposition.split('filename=')[1] : 'export.xlsx'
      link.setAttribute('download', downloadName)
      document.body.appendChild(link)
      link.click()
      link.remove()

      store.dispatch('grid/updateDownloadNotification', {
        id: downloadName,
        progress: 100,
        completed: true,
        view: 'UnitCommanders',
        url,
        download: downloadName,
        title: 'Reporte Comandantes de Unidad',
        body: 'Descarga completa',
        error: false,
        timestamp: `${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`,
      })
    },

    async getAll({ commit }, params) {
      const { data } = await axios.get('v1/unit-commanders', { params })

      if (!data || !data.success) {
        commit('setData', [])
        return emptyPagination()
      }

      const raw = data.data
      const isNested = raw && !Array.isArray(raw) && Array.isArray(raw.data)
      const items = isNested ? raw.data : (Array.isArray(raw) ? raw : [])
      const meta = isNested ? (raw.meta || {}) : (data.meta || {})
      const links = isNested ? (raw.links || {}) : (data.links || {})
      commit('setData', items)
      return { data: items, meta, links }
    },
    async getById(_, id) {
      const { data } = await axios.get(`v1/unit-commanders/${id}`)
      return data
    },
    async add(_, params) {
      const { data } = await axios.post('v1/unit-commanders', params)
      return data
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/unit-commanders/${id}`, params)
      return data
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/unit-commanders/${id}`)
      return data
    },
    clear({ commit }) {
      commit('setData', [])
    },
  },
}
